var map = {
	"./black-white.png": 41287,
	"./bulk-add-on.png": 75731,
	"./business-docs.png": 75776,
	"./chargebacks.png": 22120,
	"./finance.png": 28812,
	"./helpdesk.svg": 93330,
	"./manual-payments-single.png": 35321,
	"./manual-payments.png": 52203,
	"./mass-payout.png": 51867,
	"./moto-payments.png": 44035,
	"./new-payment-link.png": 51560,
	"./new-report.png": 69838,
	"./payment-confirmations.png": 81332,
	"./payment-link.png": 26413,
	"./projects.png": 87076,
	"./reports.png": 45618,
	"./risks.png": 70221,
	"./single-add-on.png": 60289,
	"./team.png": 37542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15546;